import { upperSnakeCaseToLowerCase } from './upperSnakeCaseToLowerCase';

export function getTradePlanUpdateText(parsedDetails) {
  if (!parsedDetails) return '';
  if (parsedDetails?.updateType) {
    return upperSnakeCaseToLowerCase(parsedDetails.updateType);
  } else return '';
}
